import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Card, Stack, Typography } from '@mui/material';

import { useSyncKoObservable } from '@/hooks/useSyncKoObservable';
import { Instance as userService } from '@/legacy/services/user';
import { durandalRoutes } from '@/routes/durandal';

export const VerifyNumberSuccess = (): React.JSX.Element => {
  const totalAccountingFirmMemberships = useSyncKoObservable(userService.accountingFirmMemberships);
  const totalUserMemberships = useSyncKoObservable(userService.memberships);
  const buttonHref = useMemo(() => {
    const totalAccountingFirmMembershipsCount = totalAccountingFirmMemberships?.length ?? 0;
    const totalUserMembershipsCount = totalUserMemberships?.length ?? 0;
    const totalMembershipsCount = totalAccountingFirmMembershipsCount + totalUserMembershipsCount;
    if (totalMembershipsCount === 0) {
      return durandalRoutes.user.tutorials.companyInfo;
    }
    return durandalRoutes.user.dashboard.index;
  }, [totalAccountingFirmMemberships?.length, totalUserMemberships?.length]);
  return (
    <Card sx={{ maxWidth: 377, p: [6, 5] }}>
      <Stack alignItems="center" spacing={3}>
        <Typography textAlign="center" variant="h3">
          <FormattedMessage defaultMessage="You have already verified your phone number" />
        </Typography>
        <Button color="primary" fullWidth href={buttonHref} sx={{ mt: 2 }}>
          <FormattedMessage defaultMessage="Continue" />
        </Button>
      </Stack>
    </Card>
  );
};
